import { render, staticRenderFns } from "./ArrivalOrder.vue?vue&type=template&id=32deacdf&scoped=true&"
import script from "./ArrivalOrder.vue?vue&type=script&lang=js&"
export * from "./ArrivalOrder.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalOrder.vue?vue&type=style&index=0&id=32deacdf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32deacdf",
  null
  
)

export default component.exports